// extracted by mini-css-extract-plugin
export default {"crossIconContainer":"_2m9Tizhz","locationInputDefaultContainer":"RMR2u1EZ"};